import { Link } from 'react-router-dom';
import I18n from '../../../config/i18n';
import { getIndexFor } from '../reducers';
import DropdownSelect from '../../../utils/dropdownSelect/DropdownSelect';
import DateInput from '../../../utils/forms/DateInput';
import type { OptionsValue } from '../static/staticOptions';

import './SearchWidgetSmall.css';

interface SearchWidgetSmallProps {
  options: {
    durations: OptionsValue[];
    occupancies: OptionsValue[];
  };
  values: {
    arrival: moment.Moment | null;
    duration: number | null;
    occupancy: number;
  };
  actionUrl: string;
  withButton: boolean;
  onArrivalChange: (date: moment.Moment | null) => void;
  onDurationChange: (duration: OptionsValue) => void;
  onOccupancyChange: (occupancy: OptionsValue) => void;
}

export default function SearchWidgetSmall({
  values,
  options,
  ...props
}: SearchWidgetSmallProps): JSX.Element {
  return (
    <div className="search-widget-small">
      <div className="search-widget-small-item search-widget-small-item__arrival-input">
        <label htmlFor="arrival">{I18n.t('search.arrival')}</label>
        <DateInput
          id="arrival"
          placeholder={I18n.t('search.arrival')}
          value={values.arrival ? values.arrival : null}
          onChange={props.onArrivalChange}
          onBlur={() => null}
        />
      </div>
      <div className="search-widget-small-item">
        <DropdownSelect
          selectedIndex={getIndexFor(values.duration, options.durations)}
          options={options.durations}
          onChange={props.onDurationChange}
        />
      </div>
      <div className="search-widget-small-item">
        <DropdownSelect
          selectedIndex={getIndexFor(values.occupancy, options.occupancies)}
          options={options.occupancies}
          onChange={props.onOccupancyChange}
        />
      </div>
      {props.withButton ? (
        <div className="search-widget-small-item">
          <Link to={props.actionUrl} className="search-widget-button">
            {I18n.t('homepage_customer.search_button')}
          </Link>
        </div>
      ) : null}
    </div>
  );
}
